import { useState, useCallback } from 'react';
import { API_BASE_URL } from '../../../../constants';

/**
 * useSkillDetail — custom hook for fetching full skill detail (with conditions/effects)
 * Includes local cache to avoid re-fetching the same skill.
 */
const useSkillDetail = () => {
    const [cache, setCache] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchSkill = useCallback(async (idSkill) => {
        if (cache[idSkill]) return cache[idSkill];

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/api/skill/${idSkill}`);
            if (!res.ok) throw new Error(`Failed (${res.status})`);
            const data = await res.json();
            setCache(prev => ({ ...prev, [idSkill]: data }));
            return data;
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    }, [cache]);

    return { fetchSkill, loading };
};

export default useSkillDetail;
